/**
 * @author PengWen
 * @description 岗位兼职信息管理页面配置
 * @Date 2022/11/28
 */
 import React, { Component } from 'react';
 import PropTypes from 'prop-types';
 import { Form, Cascader, InputNumber } from 'antd'
 import { component_tool, framework_tool } from '@/tool'
 import "./index.less";
 let {
     WizButton,
     WizSelect,
     WizTooltip,
     WizInput,
     WizIcon,
     WizSwitch,
     WizLocationSelect,
     WizRow,
     WizCol,
     WizRadio,
     WizDivider,
     WizCheckbox,
     WizInputNumber
 } = component_tool;
 let WizForm = Form
 let Item = Form.Item
 let Option = WizSelect.Option
 let OptGroup = WizSelect.OptGroup
 import { WizTableForm, WizAuthority } from '@/containers/common';
 const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1, organizationNodeCategory: ["2"] } })
 const positionConfig = WizTableForm.Config.positionName(this, { apiParams: { state: 1 } })
 const pathStage = WizTableForm.Config.pathStage(this, { apiParams: { state: 2 } })
 const cert = WizTableForm.Config.cert(this, { apiParams: { state: 1,type:1 } })
 const offlineProgram = WizTableForm.Config.offlineProgram(this, { apiParams: { status: 1 } })
 const exam = {...WizTableForm.Config.exam(this, { apiParams: { status: 1 } })}
 const path = WizTableForm.Config.path(this, { apiParams: {  state: 2} })

 /**
  * 此组件没有继承WizComponent，因为需要使用Form.create()该组件
  * 继承WizComponent后 form的部分功能缺失了
  * 初步怀疑是WizComponent修改了生命周期的钩子导致的
  * by mll 2020-2-4
  */

 class RequirementPartTimePositionForm extends Component {

     constructor(props) {
         super(props);
         const {oldNewShop} = props.data
         this.state = {
             date: new Date().getTime(),
             configCountShow : !oldNewShop
         }
     }

     componentDidMount() {
     }

     _renderOption(){
         let rows = [{ code: 1, codeName: '4S网点' },
         { code: 2, codeName: '直营店' },
         { code: 3, codeName: '单一售后' },
         { code: 4, codeName: '单一销售' },
         { code: 5, codeName: '卫星店/直营店' },
         { code: 6, codeName: '自修站' },
         { code: 7, codeName: '卫星店' },
         { code: 8, codeName: '精品店' },
         { code: 9, codeName: 'dealer' },
         { code: 10, codeName: '4S店' },
         { code: 11, codeName: '汽车零售' },
         { code: 12, codeName: '单一销售展厅' },
         { code: 13, codeName: 'NEV单一售后' },
         { code: 14, codeName: '轻量化4S网点' },
         { code: 15, codeName: 'NEV专区' },
         { code: 16, codeName: '商超店' },
           { code: 17, codeName: '自修店' },
           { code: 18, codeName: '二级网点' },
           { code: 19, codeName: '车工坊C1' },
           { code: 20, codeName: '车工坊C2' },
           { code: 21, codeName: '车工坊B' },
           { code: 22, codeName: '德科品牌授权经销商' },
         { code: 0, codeName: '无' }]

         let options = []
         rows.forEach(row=>{
             let option =
                 <WizSelect.Option key={'option' + row['code']} value={row['codeName']} title={row['codeName']}>
                     {row['codeName']}
                 </WizSelect.Option>
             options.push(option);
         })
         return (
             options
           )

     }

     /**
      * 表单基础内容
      */
     _base() {
         const { data, form } = this.props;
         let { getFieldDecorator } = form;
         return [
             <Item label="组织" >
                 {getFieldDecorator('orgId', {
                     rules: [{ required: true, message: '请选择组织' }],
                     initialValue: data[`orgId`] || null,
                 })(
                     <WizTableForm
                         {...organizationConfig}
                         key={'orgId' + "@" + this.state.date}
                         selectType={'radio'}
                         initRows={data[`orgId`] ? [{ id: data[`orgId`], name: data[`name`] }] : []}
                     />
                 )}
             </Item>,
             <Item label="岗位1" >
                 {getFieldDecorator('positionIdA', {
                     rules: [{ required: true, message: '请选择岗位' }],
                     initialValue: data[`positionA`] || null,
                 })(
                     <WizTableForm
                         {...positionConfig}
                         key={'positionA' + "@" + this.state.date}
                         selectType={'radio'}
                         initRows={data[`positionA`] ? [{ id: data[`positionA`], name: data[`positionAStr`] }] : []}
                     />
                 )}
             </Item>,
             <Item label="岗位2" >
             {getFieldDecorator('positionIdB', {
                 rules: [{ required: true, message: '请选择岗位' }],
                 initialValue: data[`positionB`] || null,
             })(
                 <WizTableForm
                     {...positionConfig}
                     key={'positionB' + "@" + this.state.date}
                     selectType={'radio'}
                     initRows={data[`positionB`] ? [{ id: data[`positionB`], name: data[`positionBStr`] }] : []}
                 />
             )}
         </Item>,

 <Item label="站点类型">
 {getFieldDecorator('dealerTypeList', {
     rules: [{ required: true, message: '请选择站点类型' }],
     initialValue: data.dealerTypeList ? data.dealerTypeList : [],
 })(

     <WizCheckbox.Group>
         <WizRow>
             <WizCol span={6}>
             <WizCheckbox value={1} >4S网点</WizCheckbox>
             </WizCol>
             <WizCol span={6}>
             <WizCheckbox value={2} >直营店</WizCheckbox>
             </WizCol>
             <WizCol span={6}>
             <WizCheckbox value={3} >单一售后</WizCheckbox>
             </WizCol>
             <WizCol span={6}>
             <WizCheckbox value={4} >单一销售</WizCheckbox>
             </WizCol>
         </WizRow>
         <WizRow>
             <WizCol span={6}>
             <WizCheckbox value={5} >卫星店/直营店</WizCheckbox>
             </WizCol>
             <WizCol span={6}>
             <WizCheckbox value={6} >自修站</WizCheckbox>
             </WizCol>
             <WizCol span={6}>
             <WizCheckbox value={7} >卫星店</WizCheckbox>
             </WizCol>
             <WizCol span={6}>
             <WizCheckbox value={8} >精品店</WizCheckbox>
             </WizCol>
         </WizRow>
         <WizRow>
             <WizCol span={6}>
             <WizCheckbox value={9} >dealer</WizCheckbox>
             </WizCol>
             <WizCol span={6}>
             <WizCheckbox value={10} >4S店</WizCheckbox>
             </WizCol>
             <WizCol span={6}>
             <WizCheckbox value={11} >汽车零售</WizCheckbox>
             </WizCol>
             <WizCol span={6}>
             <WizCheckbox value={12} >单一销售展厅</WizCheckbox>
             </WizCol>
         </WizRow>
         <WizRow>
             <WizCol span={6}>
             <WizCheckbox value={13} >NEV单一售后</WizCheckbox>
             </WizCol>
             <WizCol span={6}>
             <WizCheckbox value={14} >轻量化4S网点</WizCheckbox>
             </WizCol>
             <WizCol span={6}>
             <WizCheckbox value={15} >NEV专区</WizCheckbox>
             </WizCol>
             <WizCol span={6}>
             <WizCheckbox value={0} >无</WizCheckbox>
             </WizCol>
         </WizRow>
       <WizRow>
         <WizCol span={6}>
           <WizCheckbox value={16} >商超店</WizCheckbox>
         </WizCol>
         <WizCol span={6}>
           <WizCheckbox value={17} >自修店</WizCheckbox>
         </WizCol>
         <WizCol span={6}>
           <WizCheckbox value={18} >二级网点</WizCheckbox>
         </WizCol>
         <WizCol span={6}>
           <WizCheckbox value={19} >车工坊C1</WizCheckbox>
         </WizCol>
       </WizRow>
       <WizRow>
         <WizCol span={6}>
           <WizCheckbox value={20} >车工坊C2</WizCheckbox>
         </WizCol>
         <WizCol span={6}>
           <WizCheckbox value={21} >车工坊B</WizCheckbox>
         </WizCol>
         <WizCol span={6}>
           <WizCheckbox value={22} >德科品牌授权经销商</WizCheckbox>
         </WizCol>
       </WizRow>
     </WizCheckbox.Group>,
 )}
 </Item>,

             <Item label="状态">
                 {getFieldDecorator('status', {
                     rules: [{ required: true, }],
                     initialValue: data.status === 0 ? data.status : 1
                 })(
                     <WizRadio.Group>
                         <WizRadio value={1}>有效</WizRadio>
                         <WizRadio value={0}>无效</WizRadio>
                     </WizRadio.Group>,
                 )}
             </Item>,

         ]
     }
     handleReset = () => {
         //重置表单
         this.setState({
             date: new Date().getTime()
         })
         this.props.form.resetFields();
     };

     /**
      * 表单提交按钮
      */
     _submit() {
         return (
             <Item wrapperCol={{ span: 12, offset: 6 }}>
                 <WizRow>
                     <WizCol span={24} style={{ textAlign: 'center' }}>
                         <WizButton type="primary" htmlType="submit">
                             保存
                         </WizButton>
                         <WizButton style={{ marginLeft: 20 }} onClick={this.handleReset}>
                             重置
                         </WizButton>
                     </WizCol>
                 </WizRow>
             </Item>
         )
     }

     _dividerName = (dividerName) => {
         return [
             <Item wrapperCol={{ span: 18, offset: 3 }}>
                 <WizDivider>
                     {dividerName}
                 </WizDivider>
             </Item>,
         ]
     }

     /**
     * 处理表单提交事件
     */
     handleSubmit = e => {
         let { submit } = this.props;
         e.preventDefault();
         this.props.form.validateFields((err, values) => {
             if (!err) {
                 submit && submit(values)
             }
         });
     };

     render() {
         let type = this.props.form.getFieldValue("type")
         const formItemLayout = {
             labelCol: { span: 6 },
             wrapperCol: { span: 14 },
         };
         return (
             <WizForm
                 {...formItemLayout}
                 onSubmit={this.handleSubmit}
             >
                 {this._base()}
                 {this._submit()}
             </WizForm>
         )
     }
 }

 export default WizForm.create()(RequirementPartTimePositionForm);

 /**
  * 默认值
  */
  RequirementPartTimePositionForm.defaultProps = {
     data: {},
     selects: []
 }

 /**
  * props入参校验
  */
  RequirementPartTimePositionForm.propTypes = {
 }

